import { render, staticRenderFns } from "./TypeChip.vue?vue&type=template&id=779dc8d2"
import script from "./TypeChip.vue?vue&type=script&lang=js"
export * from "./TypeChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports